import React from 'react';
import { IconButton } from '../buttons';
import { Toggle, FixedNavToggle, NavToggleBar } from './style';

const NavToggle = ({ onClick, isExpanded, color = '#fff' }) => (
  <IconButton
    onClick={onClick}
    css={`
      position: relative;
    `}
  >
    <NavToggleBar isExpanded={isExpanded} color={color} />
  </IconButton>
);

export { NavToggle, NavToggleBar, FixedNavToggle };
export default Toggle;



// WEBPACK FOOTER //
// ./src/components/toggle/index.js